/* 05 私のご褒美シリーズ（2026-10-02）：チャイ／出汁ソルトの切り替えと、選んだ味の説明。カートに入れる・価格の切り替えは kz-buy.js。
   ・切り替えはスマホの小さな写真とPCの大きな写真の2組。どちらを押しても同じ欄が開く（左右・上下キーでも）
   ・出汁ソルトは料理の札を押すと、合う小瓶（味）が選ばれる。小瓶を直接選ぶと、その味に合う最初の料理の札が光る */
(() => {
  const init = (sec) => {
    if (sec.dataset.kgsOn) return;
    sec.dataset.kgsOn = '1';
    const tabs = [...sec.querySelectorAll('[data-kgs-tab]')];
    const panels = [...sec.querySelectorAll('.kgs__panel')];
    const show = (i) => {
      tabs.forEach((t) => {
        const on = t.dataset.kgsTab === String(i);
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach((p, k) => {
        const on = k === i;
        p.classList.toggle('is-on', on);
        p.toggleAttribute('inert', !on);
      });
    };
    tabs.forEach((t) => {
      t.addEventListener('click', () => show(Number(t.dataset.kgsTab)));
      t.addEventListener('keydown', (e) => {
        if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
        e.preventDefault();
        const list = [...t.parentElement.querySelectorAll('[data-kgs-tab]')];
        const fwd = e.key === 'ArrowRight' || e.key === 'ArrowDown';
        const n = list[(list.indexOf(t) + (fwd ? 1 : list.length - 1)) % list.length];
        show(Number(n.dataset.kgsTab));
        n.focus();
      });
    });

    /* チャイ：湯のみ（味）と「この味を1杯／5種を飲み比べ」から、カートに入れる品（id）と価格・説明を決める */
    sec.querySelectorAll('[data-kgs-form="chai"]').forEach((form) => {
      const hid = form.querySelector('[data-kgs-id]');
      const price = form.querySelector('[data-kz-price]');
      const name = form.querySelector('[data-kgs-name]');
      const desc = form.querySelector('[data-kgs-desc]');
      const btn = form.querySelector('[data-kz-add]');
      /* 2026-10-06 案D（ご本人「チャイを最初から5種で」）：説明は「。」「、」の後ろで区切り、折り返さない span（kgs-nb）に入れる。
         最初に出る5種の説明が、360〜390px幅で「飲み比べのセ／ット。」と折れていたため（よく合う料理の setPair と同じやり方） */
      const setDesc = (s) => {
        const parts = String(s || '').replace(/([。、])/g, '$1\n').split('\n').filter(Boolean);
        desc.replaceChildren(...parts.map((t) => { const sp = document.createElement('span'); sp.className = 'kgs-nb'; sp.textContent = t; return sp; }));
      };
      const upd = (anim) => {
        const f = form.querySelector('input[name="kgs-flavor"]:checked');
        const k = form.querySelector('input[name="kgs-kind"]:checked');
        const set = !!k && k.value === 'set';
        const src = set ? k : f;
        if (!src || !hid) return;
        hid.value = set ? k.dataset.id : f.value;
        if (name) name.textContent = src.dataset.name || '';
        if (desc) setDesc(src.dataset.desc);
        if (btn) btn.disabled = !!src.disabled;
        if (price && price.textContent !== src.dataset.price) {
          price.textContent = src.dataset.price;
          if (anim) { price.classList.remove('is-flip'); void price.offsetWidth; price.classList.add('is-flip'); }
        }
        form.classList.toggle('is-set', set);
      };
      form.addEventListener('change', (e) => {
        /* 湯のみを選んだら「この味を1杯」に戻す */
        if (e.target && e.target.name === 'kgs-flavor') {
          const one = form.querySelector('input[name="kgs-kind"][value="one"]');
          if (one) one.checked = true;
        }
        upd(true);
      });
      /* 5種のとき、選んであった湯のみをもう一度押しても1杯に戻す（ラジオは同じものを押しても change が出ない） */
      form.querySelectorAll('input[name="kgs-flavor"]').forEach((i) => i.addEventListener('click', () => {
        const one = form.querySelector('input[name="kgs-kind"][value="one"]');
        if (one && !one.checked) { one.checked = true; upd(true); }
      }));
      upd(false);
    });

    sec.querySelectorAll('[data-kgs-form="salt"]').forEach((form) => {
      const name = form.querySelector('[data-kgs-name]');
      const desc = form.querySelector('[data-kgs-desc]');
      const pair = form.querySelector('[data-kgs-pair]');
      const dishes = [...form.querySelectorAll('.kgs__dish')];
      const picked = () => form.querySelector('[data-kz-opt="0"] input:checked');
      /* よく合う料理：料理名ごとに折り返さない span（kgs-nb）に分け、読点のところだけで折れるようにする（2026-10-03） */
      const setPair = (s) => {
        const items = String(s || '').split('、').filter(Boolean);
        pair.replaceChildren(...items.map((t, i) => {
          const sp = document.createElement('span');
          sp.className = 'kgs-nb';
          sp.textContent = t + (i < items.length - 1 ? '、' : '');
          return sp;
        }));
      };
      const update = () => {
        const r = picked();
        if (!r) return;
        if (name) name.textContent = r.dataset.name || r.value;
        if (desc) desc.textContent = r.dataset.desc || '';
        if (pair) setPair(r.dataset.pair);
        if (dishes.length) {
          const cur = dishes.find((d) => d.classList.contains('is-on'));
          if (!cur || cur.dataset.salt !== r.value) {
            const m = dishes.find((d) => d.dataset.salt === r.value);
            dishes.forEach((d) => d.classList.toggle('is-on', d === m));
          }
        }
      };
      form.addEventListener('change', update);
      dishes.forEach((d) => d.addEventListener('click', () => {
        const r = [...form.querySelectorAll('[data-kz-opt="0"] input')].find((i) => i.value === d.dataset.salt);
        if (!r) return;
        dishes.forEach((x) => x.classList.toggle('is-on', x === d));
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      update();
    });
  };
  /* 04 の献立「この塩を選ぶ ↓」「チャイを選ぶ ↓」（2026-10-03）：05 を開いて、その品を選んだ状態にする。
     data-kgs-jump="salt:料理の札の名前"（その札を押したのと同じ）／"chai"。05 が無いときは、ふつうのページ内リンク */
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('[data-kgs-jump]');
    if (!a) return;
    const sec = document.getElementById('section-05');
    if (!sec || !sec.hasAttribute('data-kgs')) return;
    e.preventDefault();
    const [kind, dish] = a.dataset.kgsJump.split(':');
    const want = kind === 'chai' ? '0' : '1';
    const tabs = [...sec.querySelectorAll(`[data-kgs-tab="${want}"]`)];
    const tab = tabs.find((t) => t.offsetParent !== null) || tabs[0];
    if (tab) tab.click();
    if (dish) { const d = [...sec.querySelectorAll('.kgs__dish')].find((x) => x.textContent.trim() === dish); if (d) d.click(); }
    sec.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#section-05');
  });
  const run = () => document.querySelectorAll('[data-kgs]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
